import { LAND } from "@constants/images";
import Marquee from "react-fast-marquee";

const GangstaverseLand = () => {
  return (
    <div className="gangstaverse-land-bg ">
      <div className="gangstaverse-stat-wrapper">
        <div className="gangstaverse-land-heading animate__animated animate__fadeInUp animate-duration-1s">
          Lands in Emerald city
        </div>
        <p className="gangstaverse-stat-description wow animate__animated animate__fadeInUp animate__delay-1s">
          There will be a total of 11,111 city blocks in The Emerald City. It
          represents an area of 70m x 70m and can consist of one or many
          buildings. The entire City will be divided into several regions like
          Commercial Area, Government Area, Vacation Town, Airport, Shopping
          Area, Residential Area, Park, Apartments, Suburbs, and so on. There
          will be several activities and events in the lands.
        </p>
        <div className="marquee-wrapper">
          <Marquee
            gradient={true}
            gradientColor={[0, 0, 0]}
            gradientWidth={300}
            speed={30}
          >
            <img className="gangstaverse-land-image" src={LAND.LANDTOP} />{" "}
          </Marquee>

          <Marquee
            gradient={true}
            gradientColor={[0, 0, 0]}
            gradientWidth={300}
            speed={20}
            direction="right"
          >
            <img className="gangstaverse-land-image" src={LAND.LANDMIDDLE} />{" "}
          </Marquee>

          <Marquee
            gradientColor={[0, 0, 0]}
            gradientWidth={300}
            gradient={true}
            direction="left"
          >
            <img className="gangstaverse-land-image" src={LAND.LANDTOP} />
          </Marquee>
          <div className="overshade"></div>
        </div>
      </div>
    </div>
  );
};

export default GangstaverseLand;
